import { getTimeByOption, getViewPluginName, isDefined } from 'helpers/commons';
import {
	AGENDA_TYPES,
	EVENT_LAYOUT_TYPES,
	VIEW_PLUGIN_NAMES,
	WEEK_DAYS_HIDE_OPTIONS,
	TEMPORARY_VIEW_PLUGIN_NAMES
} from 'helpers/constants';
import { setTemporaryView } from 'store/actions';
import {
	TIMELINE_ALIGNMENT_TYPES,
	TIMELINE_DATE_TYPES,
	TIMELINE_HORIZONTAL_ALIGNMENT_TYPES,
	TIMELINE_VERTICAL_ALIGNMENT_TYPES
} from 'helpers/constants';
import { CROSS_TYPES } from 'helpers/constants';

export const updateViews = (current, updates, dispatch, updateNeeded) => {
	const { numbers, booleans } = updates;
	if (updateNeeded.booleans) {
		if (isDefined(booleans.mapShownOnlyUpcomings))
			current.mapSpecifics.shownOnlyUpcomings = booleans.mapShownOnlyUpcomings;
		if (isDefined(booleans.agendaShownOnlyUpcomings))
			current.agendaSpecifics.shownOnlyUpcomings = booleans.agendaShownOnlyUpcomings;
		if (isDefined(booleans.agendaShowAdditionalDate))
			current.agendaSpecifics.showAdditionalDate = booleans.agendaShowAdditionalDate;
		if (isDefined(booleans.agendaMonthSeparator))
			current.agendaSpecifics.monthSeparator = booleans.agendaMonthSeparator;
		if (isDefined(booleans.agendaTooltipPopup))
			current.agendaSpecifics.agendaTooltipPopup = booleans.agendaTooltipPopup;
		if (isDefined(booleans.gridShownOnlyUpcomings))
			current.cardSpecifics.shownOnlyUpcomings = booleans.gridShownOnlyUpcomings;
		if (isDefined(booleans.timelineShownOnlyUpcomings))
			current.timelineSpecifics.shownOnlyUpcomings = booleans.timelineShownOnlyUpcomings;
		if (isDefined(booleans.crossShowOnlyUpcoming))
			current.crossSpecifics.crossShowOnlyUpcoming = booleans.crossShowOnlyUpcoming;
		if (isDefined(booleans.fixedWeekCount))
			current.monthSpecifics.fixedWeekCount = booleans.fixedWeekCount;
		if (isDefined(booleans.mobileShowDates))
			current.monthSpecifics.mobileShowDates = booleans.mobileShowDates;
		if (isDefined(booleans.showTimeMonthly))
			current.monthSpecifics.showTime = booleans.showTimeMonthly;
		if (isDefined(booleans.weatherForecastShow))
			current.monthSpecifics.weatherForecastShow = booleans.weatherForecastShow;
		if (isDefined(booleans.addCalendarButton))
			current.singleEventOptions.showAddToIcons = booleans.addCalendarButton;
		if (isDefined(booleans.shareEvents))
			current.singleEventOptions.showShareIcons = booleans.shareEvents;
		if (isDefined(booleans.showTitleInMobile))
			current.singleEventOptions.showEventTitleInMobile = booleans.showTitleInMobile;
		if (isDefined(booleans.showSkeletonInMobile))
			current.singleEventOptions.showSkeletonInMobile = booleans.showSkeletonInMobile;
		if (isDefined(booleans.categoryShow)) current.showCategoryBlock = booleans.categoryShow;
		if (isDefined(booleans.showMobileNoEventsText))
			current.singleEventOptions.showMobileNoEventsText = booleans.showMobileNoEventsText;
		if (isDefined(booleans.showShowMoreButton))
			current.singleEventOptions.showShowMoreButton = booleans.showShowMoreButton;
		if (isDefined(booleans.customViewShowOnlyUpcoming))
			current.customViewSpecifics.customViewShowOnlyUpcoming =
				booleans.customViewShowOnlyUpcoming;

		current.weekDaysHidden = WEEK_DAYS_HIDE_OPTIONS.reduce((acc, option, index) => {
			return isDefined(booleans[option]) && !booleans[option] ? [...acc, index] : acc;
		}, []);
	}
	if (updateNeeded.numbers) {
		if (isDefined(numbers.popType))
			current.singleEventOptions.singleEventLayout =
				Object.values(EVENT_LAYOUT_TYPES)[+numbers.popType];
		if (isDefined(numbers.listViewType)) current.listSpecifics.type = numbers.listViewType;
		if (isDefined(numbers.yearViewStyle)) current.yearlySpecifics.style = numbers.yearViewStyle;
		if (isDefined(numbers.defaultView) || isDefined(numbers.defaultViewMobile)) {
			let viewIndex = numbers.defaultView;

			if (current.isMobile && numbers.defaultViewMobile !== undefined) {
				viewIndex = numbers.defaultViewMobile;
			}

			current.currentView = getViewPluginName({
				viewIndex,
				showHours: !numbers.showHoursW,
				viewNames: VIEW_PLUGIN_NAMES,
				listViewType: current.listSpecifics.type,
				yearViewStyle: current.yearlySpecifics.style
			});
		}
		if (isDefined(numbers.agendaReverse))
			current.agendaSpecifics.reversed = !!numbers.agendaReverse;
		if (isDefined(numbers.timelineReverse))
			current.timelineSpecifics.reversed = !!numbers.timelineReverse;
		if (isDefined(numbers.agendaStyle))
			current.agendaSpecifics.style = AGENDA_TYPES[numbers.agendaStyle];
		if (isDefined(numbers.agendaEventLimit))
			current.agendaSpecifics.limit = numbers.agendaEventLimit;
		if (isDefined(numbers.timelineEventLimit))
			current.timelineSpecifics.limit = numbers.timelineEventLimit;
		if (isDefined(numbers.listViewType)) current.listSpecifics.type = numbers.listViewType;
		if (isDefined(numbers.gridReverse)) current.cardSpecifics.reversed = !!numbers.gridReverse;
		if (isDefined(numbers.gridEventLimit)) current.cardSpecifics.limit = numbers.gridEventLimit;
		if (isDefined(numbers.gridCardsInRow))
			current.cardSpecifics.cardsInRow = numbers.gridCardsInRow;
		if (isDefined(numbers.gridCardsSpace))
			current.cardSpecifics.spaceBetweenCards = numbers.gridCardsSpace;
		if (isDefined(numbers.yearCalendarsSpace))
			current.yearlySpecifics.spaceBetweenCalendars = numbers.yearCalendarsSpace;
		if (isDefined(numbers.mapStylePicker)) current.mapSpecifics.style = numbers.mapStylePicker;
		if (isDefined(numbers.eventLimit))
			current.monthSpecifics.dailyRowsLimit = numbers.eventLimit;
		if (isDefined(numbers.weekNumbers))
			current.yearlySpecifics.showWeekNumbers = !numbers.weekNumbers;
		if (isDefined(numbers.weekNumbers))
			current.monthSpecifics.showWeekNumbers = !numbers.weekNumbers;
		if (isDefined(numbers.minTime))
			current.weekDaySpecifics.minTime = getTimeByOption(+numbers.minTime);
		if (isDefined(numbers.weatherForecastCity))
			current.monthSpecifics.weatherForecastCity = numbers.weatherForecastCity;
		if (isDefined(numbers.maxTime))
			current.weekDaySpecifics.maxTime = getTimeByOption(
				+numbers.maxTime + 1,
				current.weekDaySpecifics.minTime
			);
		if (isDefined(numbers.eventLimit)) current.dayMaxEvents = +numbers.eventLimit;
		if (isDefined(numbers.categorySectionPosition))
			current.categoryInFooter = !!numbers.categorySectionPosition;
		if (
			isDefined(numbers.showHoursW) &&
			current.weekDaySpecifics.showHours !== !numbers.showHoursW
		) {
			current.weekDaySpecifics.showHours = !numbers.showHoursW;
			if (
				isDefined(current.temporaryView) &&
				VIEW_PLUGIN_NAMES[1].includes(current.temporaryView)
			) {
				const processedTemporaryView = getViewPluginName({
					viewIndex: 1,
					showHours: !numbers.showHoursW,
					viewNames: TEMPORARY_VIEW_PLUGIN_NAMES,
					listViewType: current.listSpecifics.type,
					yearViewStyle: current.yearlySpecifics.style
				});
				current.temporaryView = processedTemporaryView;
				dispatch(setTemporaryView(processedTemporaryView));
			}
		}
		if (isDefined(numbers.aspectRatio)) {
			current.proportions = numbers.aspectRatio;
		}

		//Cross
		if (isDefined(numbers.crossStyle))
			current.crossSpecifics.style = CROSS_TYPES[numbers.crossStyle];
		if (isDefined(numbers.crossCardSpasce))
			current.crossSpecifics.crossCardSpasce = numbers.crossCardSpasce;
		if (isDefined(numbers.crossViewColumnProportions))
			current.crossSpecifics.crossViewColumnProportions = numbers.crossViewColumnProportions;
		if (isDefined(numbers.crossAlign)) current.crossSpecifics.crossAlign = numbers.crossAlign;
		if (isDefined(numbers.crossReverse))
			current.crossSpecifics.crossReverse = numbers.crossReverse;
		if (isDefined(numbers.corssEventLimit))
			current.crossSpecifics.corssEventLimit = numbers.corssEventLimit;
		if (isDefined(numbers.crossImageOpacity))
			current.crossSpecifics.crossImageOpacity = numbers.crossImageOpacity / 100;
		if (isDefined(numbers.timelineAlignmentType)) {
			current.timelineSpecifics.type =
				TIMELINE_ALIGNMENT_TYPES[numbers.timelineAlignmentType];
		}
		if (isDefined(numbers.timelineVerticalAlignmentType)) {
			current.timelineSpecifics.verticalAlignmentType =
				TIMELINE_VERTICAL_ALIGNMENT_TYPES[numbers.timelineVerticalAlignmentType];
		}
		if (isDefined(numbers.timelineHorizontalAlignmentType)) {
			current.timelineSpecifics.horizontalAlignmentType =
				TIMELINE_HORIZONTAL_ALIGNMENT_TYPES[numbers.timelineHorizontalAlignmentType];
		}
		if (isDefined(numbers.timelineDateType)) {
			current.timelineSpecifics.dateType = TIMELINE_DATE_TYPES[numbers.timelineDateType];
		}

		// Custom View
		if (isDefined(numbers.customViewEventLimit))
			current.customViewSpecifics.customViewEventLimit = numbers.customViewEventLimit;
		if (isDefined(numbers.customViewReverse))
			current.customViewSpecifics.customViewReverse = numbers.customViewReverse;
	}
};
